module.exports = __webpack_public_path__ + "img/back.76e467c8.jpg";